import SourcePlaceholder from "assets/svgs/source.svg";
import dateString from "helpers/dateString";

export default function Sources({ caseSourcesRecords }) {
  return (
    <ul className="md:gap-6 md:grid md:grid-cols-2 my-6">
      {caseSourcesRecords.map((source, index) => {
        const {
          classification,
          icon_url,
          publication_date,
          source_name,
          title,
          url,
        } = source;

        const iconOrPlaceholderUrl = (icon_url && icon_url.indexOf("airtable") === -1) ? icon_url : null;
        return (
          <li className="flex mt-6 md:mt-0" key={index}>
            {url && (
              <a
                className="bg-white block border p-2 w-full hover:elevation-0"
                href={url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <figure className="flex items-start overflow-hidden">
                  <div className="flex-shrink-0	h-14 mr-4 text-gray-400 w-14">
                    {iconOrPlaceholderUrl ? (
                      <img src={iconOrPlaceholderUrl} height="56" width="56" />
                    ) : (
                      <SourcePlaceholder className="mx-auto" width="26" />
                    )}
                  </div>
                  <figcaption className="flex flex-col text-sm">
                    {publication_date && (
                      <small className="text-gray-500 text-xs">
                        {publication_date != "Invalid Date"
                          ? dateString(publication_date)
                          : null}
                      </small>
                    )}
                    {title ? (
                      <span className="font-semibold my-1 text-red">
                        {title}
                      </span>
                    ) : (
                      <span className="font-semibold my-1 text-red">
                        External Case File
                      </span>
                    )}
                    <small className="text-sm text-gray-500">
                      {source_name && source_name}{" "}
                      {source_name && classification ? <>&bull;</> : null}{" "}
                      {classification && classification}
                    </small>
                  </figcaption>
                </figure>
              </a>
            )}
          </li>
        );
      })}
    </ul>
  );
}
